// extracted by mini-css-extract-plugin
export default {"empty_states":"styles_empty_states__iyVR0","spin":"styles_spin__laVQ1"};